module.exports = __webpack_public_path__ + "static/img/master_studio_member_1.a88f3ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/master_studio_member_1.png
// module id = IC3c
// module chunks = 11